/**
 * Housekeeping Web - load state of the tenant cell features
 *
 * SE Traceability:
 * - Requirements: REQ-HotelTenancy-1158
 * - Function: F-WEB-TENANT - Dashboard tenant cell
 * - Function Requirements: FR-WEB-TENANT-006 (Error Handling: features stay off, retry possible)
 *
 * Only in a cell build with a signed-in user. Legacy (XZLLENZ) never renders anything here.
 */

import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useCellFeatures, useCellFeaturesRetry } from '../contexts/CellFeaturesContext';
import { getTenantRuntime } from '../config/tenant';

/** sepipe: REQ-HotelTenancy-1158 */
export const CellFeaturesNotice: React.FC = () => {
  const { user } = useAuth();
  const state = useCellFeatures();
  const retry = useCellFeaturesRetry();
  if (!user || getTenantRuntime().legacy || state.status === 'ready') {
    return null;
  }
  if (state.status === 'loading') {
    return <p role="status" className="sr-only">Funktionen werden geladen</p>;
  }
  return (
    <div role="alert" className="mx-auto mt-4 max-w-md rounded-md bg-amber-50 p-4">
      <div className="flex">
        <AlertCircle className="h-5 w-5 flex-shrink-0 text-amber-500" aria-hidden="true" />
        <div className="ml-3">
          <h2 className="text-sm font-medium text-amber-800">Funktionen nicht geladen</h2>
          <p className="mt-1 text-sm text-amber-700">
            Die freigeschalteten Funktionen konnten nicht abgerufen werden. Bis dahin bleiben sie ausgeschaltet.
          </p>
          <button type="button" onClick={retry} className="mt-2 text-sm font-medium text-amber-800 underline">
            Erneut versuchen
          </button>
        </div>
      </div>
    </div>
  );
};
